import { useEffect, useState } from 'react';
import moment from 'moment';
import InputField from '@/components/customercenter-ui/common/validateForm/inputField';
import LockIcon from '@/components/customercenter-ui/icons/lock';
import { useCheckout } from '@/context/checkoutProvider';
import { formatDOB } from '@/customercenter-ui/utils/formatUtils';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';

const UserInfo = ({ register, errors, setValue, disableDob, disableSsn }: any) => {
  const { setFormValues, soaCustomer } = useCheckout();
  const [dob, setDob] = useState<string>('');
  const [ssn, setSsn] = useState<string>('');
  const [creditAccountNumber, setCreditAccountNumber] = useState<string>('');
  const [isCreditAccount, setIsCreditAccount] = useState<boolean>(false);

  const handleDOBInputChange = (event: any) => {
    setDob(formatDOB(event.target.value));
    setValue('dpqDOB', event.target.value);
  };

  const handleSSNInputChange = (event: any) => {
    setSsn(event.target.value);
    setValue('ssn', event.target.value);
  };

  useEffect(() => {
    setFormValues({ dob: dob });
  }, [dob]);

  useEffect(() => {
    const isCreditAccount = soaCustomer?.DivisionCustomers?.[0]?.CreditAccount ? true : false;
    if (isCreditAccount) {
      setIsCreditAccount(true);
      const creditAccountNumber = soaCustomer?.DivisionCustomers?.[0]?.CreditAccount?.creditAccountId;
      setCreditAccountNumber(creditAccountNumber);
    }
    const customerDOB = soaCustomer?.CustomerInfo?.dob ?? '';
    const formattedDob = customerDOB
      ? moment(customerDOB).isValid()
        ? moment(customerDOB).format('MM/DD/YYYY')
        : ''
      : '';
    const customerSSN = soaCustomer?.CustomerInfo?.ssn ?? '';
    setDob(formattedDob);
    setSsn(customerSSN);
    setValue('ssn', customerSSN);
    setValue('dpqDOB', formattedDob);
  }, [soaCustomer]);

  return (
    <section>
      {isCreditAccount && (
        <section>
          <p className="pb-2 text-lg font-bold">{mapLocaleToMeaningfulFormat().accountNumber}</p>
          <p className="gbmask pb-5">{creditAccountNumber}</p>
        </section>
      )}
      <section>
        <section className="pt-2">
          <section className="w-full lg:max-w-[284px]">
            <InputField
              items={mapLocaleToMeaningfulFormat().dobItem}
              id={'dob'}
              htmlFor={'dob'}
              label={'dpqDOB'}
              errors={errors}
              register={register}
              disabled={disableDob}
              classname="w-full disabled:bg-gray-200 disabled:cursor-not-allowed"
              value={dob}
              onChange={handleDOBInputChange}
              maxlength={10}
            />
          </section>
        </section>
        <section className="pl-2 pt-2">
          <section className="flex flex-row gap-2.5">
            <p className="mt-5 flex flex-row items-start text-sm tracking-[2px] lg:text-base lg:tracking-[5px]">
              {mapLocaleToMeaningfulFormat().placeholder}
            </p>
            <section className="flex flex-row gap-2">
              <section className="max-w-[166px]">
                <InputField
                  items={mapLocaleToMeaningfulFormat().lastFourSsn}
                  id={'ssn'}
                  htmlFor={'ssn'}
                  label={'ssn'}
                  errors={errors}
                  register={register}
                  disabled={disableSsn}
                  classname="w-full disabled:bg-gray-200 disabled:cursor-not-allowed"
                  maxlength={4}
                  value={ssn}
                  type="number"
                  isNum
                  onChange={handleSSNInputChange}
                />
              </section>
              <section>
                <LockIcon className="mt-5 h-[24px] w-[24px] fill-black" />
              </section>
            </section>
          </section>
        </section>
      </section>
    </section>
  );
};
export default UserInfo;
